<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-toolbar class="mb-2 pa-0" color="primary" dark flat>
          <v-toolbar-title>{{ grafTitle }}</v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="3">
        <v-autocomplete
          label="Lokalita"
          v-model="filterLokalitaId"
          :items="lokality"
          item-text="Name"
          item-value="ID"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="9">
        <v-range-slider
          label="Výber obdobia"
          v-model="filterRange"
          step="1"
          :min="filterMinYear"
          :max="filterMaxYear"
          ticks="always"
          tick-size="4"
          thumb-label="always"
        ></v-range-slider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <bar-chart
          :chart-data="grafValues(1)"
          :options="grafOptions(1)"
        ></bar-chart>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <bar-chart
          :chart-data="grafValues(2)"
          :options="grafOptions(2)"
        ></bar-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//import * as moment from "moment"
import * as Miscella from "../plugins/miscella.js"
import * as Colors from "../plugins/colors.js"
import BarChart from "../components/charts/BarChart.js"

export default {
  data: function() {
    return {
      loading: false,
      filterLokalitaId: "",
      filterRange: [1990, new Date().getFullYear()],
      filterMinYear: 1990,
      filterMaxYear: new Date().getFullYear(),
      grafData: [],
      lokality: []
    }
  },
  components: { BarChart },
  props: {},
  computed: {
    grafTitle: function() {
      return "Grafy - Pohybová aktivita"
    }
  },
  watch: {
    filterLokalitaId: {
      immediate: true,
      handler: function() {
        console.log("filterLokalitaId changed, fetching years...")
        if (this.filterLokalitaId !== "") {
          this.readChartLimits()
          this.show()
        }
      }
    },
    filterRange: function() {
      if (this.filterLokalitaId !== "") {
        this.show()
      }
    }
  },
  methods: {
    readLokality: async function() {
      try {
        this.lokality = []
        let response = await this.$axios.get("/r/lokality/mer_geo")
        if (response.status === 200) {
          this.lokality = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    grafValues: function(aIndex) {
      console.log(aIndex)
      let ret = ""
      let colors = Colors.defaultColors()
      console.log("colors", colors)
      let datasets = []
      this.grafData.forEach((item, itemIndex) => {
        let dataset = {}
        if (aIndex === 1) {
          dataset = {
            label: item.Bod,
            data: item.Items.map(function(i) {
              return { x: i.Datum, y: i.HorPosun }
            }),
            backgroundColor: colors[itemIndex],
            borderColor: colors[itemIndex],
            borderWidth: "1",
            fill: "true"
          }
          //posledne data musia byt null
          dataset.data.push({ x: "12.31." + this.filterRange[1], y: null })
        }
        if (aIndex === 2) {
          dataset = {
            label: item.Bod,
            data: item.Items.map(function(i) {
              return { x: i.Datum, y: i.VerPosun }
            }),
            backgroundColor: colors[itemIndex],
            borderColor: colors[itemIndex],
            borderWidth: "1",
            fill: "true"
          }
          //posledne data musia byt null
          dataset.data.push({ x: "12.31." + this.filterRange[1], y: null })
        }
        datasets.push(dataset)
      })
      ret = {
        datasets: datasets
      }
      return ret
    },
    grafOptions: function(aIndex) {
      let ret = ""
      switch (aIndex) {
        case 1:
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: `Zobrazenie vývoja pohybovej aktivity za obdobie (${this.filterRange[0]} - ${this.filterRange[1]}) - horizontálny posun`
            },
            scales: {
              xAxes: [
                {
                  type: "time",
                  distribution: "series",
                  time: {
                    unit: "month"
                  },
                  barThickness: "flex", //6, // number (pixels) or 'flex'
                  maxBarThickness: 8 // number (pixels),
                }
              ]
            }
          }
          break
        case 2:
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: `Zobrazenie vývoja pohybovej aktivity za obdobie (${this.filterRange[0]} - ${this.filterRange[1]}) - vertikálny posun`
            },
            scales: {
              xAxes: [
                {
                  type: "time",
                  distribution: "series",
                  time: {
                    unit: "month"
                  },
                  barThickness: "flex", // number (pixels) or 'flex'
                  maxBarThickness: 8 // number (pixels)
                }
              ]
            }
          }
          break
        default:
          break
      }
      return ret
    },
    urlFetch: function() {
      let url = "/r/chart/geo1"
      url += "?lokalitaID=" + Miscella.normalizeString(this.filterLokalitaId)
      url += "&rokOd=" + this.filterRange[0]
      url += "&rokDo=" + this.filterRange[1]
      return url
    },
    show: async function() {
      this.grafData = []
      try {
        console.log("ChartsGeo.vue, show")
        this.loading = true
        let response = await this.$axios.get(this.urlFetch())
        if (response.status === 200) {
          this.grafData = response.data.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    },
    readChartLimits: async function() {
      try {
        let response = await this.$axios.get(
          `/r/chart/limit/geo?lokalitaID=${this.filterLokalitaId}`
        )
        if (response.status === 200) {
          let chartYears = response.data.data
          this.filterMinYear = chartYears[0]
          this.filterMaxYear = chartYears[chartYears.length - 1]
          this.filterRange = [this.filterMinYear, this.filterMaxYear]
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    }
  },
  mounted: async function() {
    await this.$store.dispatch("fetchme", this.$axios)
    this.readLokality()
  }
}

/*
//Download Chart Image
document.getElementById("download").addEventListener('click', function(){
  var url_base64jp = document.getElementById("lineChart").toDataURL("image/jpg");
  var a =  document.getElementById("download");
  a.href = url_base64jp;
});
*/
</script>
